import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const assignUsersEntitlementsSlice = getBulkActionSlice(
    'assignUsersEntitlementsResult',
);

export const selectAssignUsersEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.assignUsersEntitlementsResult.shown;

export const selectAssignUsersEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.assignUsersEntitlementsResult.uuid;

export const selectAssignUsersEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.assignUsersEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = assignUsersEntitlementsSlice.actions;
